module.exports = __webpack_public_path__ + "media/images/lb/347-fdf7912c5657ada723e48539d7400e28.svg";